import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { COMPANY_ID } from "app/utils/constant";
import axiosInstance from "services/api/axiosInstance";

// fetch global labels
export const fetchGlobalLabels = createAsyncThunk(
  "common/fetchGlobalLabels",
  async (user_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/companies/${COMPANY_ID}/json-schema/labels`,
        {
          headers: {
            "x-user-id": user_id,
            "x-organisation-id": COMPANY_ID,
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

// fetch roles fixed argument
export const fetchRoles = createAsyncThunk(
  "common/fetchRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/roles`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

// fetch event labels
export const fetchEventLabels = createAsyncThunk(
  "common/fetchEventLabels",
  async ({ id, user_id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/events/${id}/json-schema/labels`,
        {
          headers: {
            "x-user-id": user_id,
            "x-organisation-id": COMPANY_ID,
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

const initialState = {
  globalLabels: null,
  userRole: null,
  eventLabels: null,
  error: null,
  loading: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Global Labels
      .addCase(fetchGlobalLabels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGlobalLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.globalLabels = action.payload;
      })
      .addCase(fetchGlobalLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // User Roles
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.userRole = action.payload;
      })

      // Event Labels
      .addCase(fetchEventLabels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.eventLabels = action.payload;
      })
      .addCase(fetchEventLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors — safe with persist
export const globalLabels = (state) =>
  state.common.globalLabels?.data ?? state.common.globalLabels;

export const userRoleLabels = (state) =>
  state.common.userRole?.data ?? state.common.userRole;

export const eventLabels = (state) =>
  state.common.eventLabels?.data ?? state.common.eventLabels;

export const { clearError } = commonSlice.actions;
export default commonSlice.reducer;
